import { OnInit, Input  } from '@angular/core';
import { UIWorkFieldModel, UIPropertyModel } from 'e5core-angular-services';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../models/work-item';

export abstract class E5coreUiWorkFieldTypeBase implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() field: UIWorkFieldModel ;
  @Input() property: UIPropertyModel;
  @Input() readonly: boolean;

  workItemModel: WorkItemModel ;

  ngOnInit() {
    if (this.workItem$ == null) {
      console.error('e5core-ui-work-field-type-input [workItem$] must have a BehaviorSubject<WorkItemModel>');
      return ;
    }
    this.workItem$.subscribe(
      n => {
        this.workItemModel = n ;
      }
    ) ;
  }

  dispatchPropertyChange(propertyId: string, value: string, error?: string) {
    const wi = {...this.workItem$.getValue()} ; // Clone
    // const prop = wi.propertyList.properties[propertyId] ;
    const prop = wi.properties.find(p => p.propertyId == propertyId) ;
    prop.resolvedValue = value ;
    prop.value = value ;
    // prop.hasError = error ;
    this.workItem$.next(wi) ;
  }

}
